import React, { useState } from "react";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import dataService from "../services/dataService";

function MeretlapNyomtatas() {
	const navigate = useStepNavigate();
	const { order } = useOrder();
	const [loading, setLoading] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [currentReport, setCurrentReport] = useState({ reportType: "", fileNamePrefix: "", reportName: "" });
	const [modalStep, setModalStep] = useState("form");
	const [modalMessage, setModalMessage] = useState("");
	const [modalOptions, setModalOptions] = useState({
		doDownload: true,
		doSendEmail: false,
		sendToPartner: true,
		customEmail: "",
		sendToCustom: true,
	});

	const downloadPDF = (base64Data, fileName) => {
		try {
			const linkSource = `data:application/pdf;base64,${base64Data}`;
			const downloadLink = document.createElement("a");
			const currentDate = new Date().toISOString().slice(0, 10);

			downloadLink.href = linkSource;
			downloadLink.download = `${fileName}_${currentDate}.pdf`;
			downloadLink.click();
		} catch (error) {
			console.error("Hiba a PDF letöltése közben:", error);
			alert("Hiba történt a PDF letöltése során.");
		}
	};

	const handlePrintDocument = async (reportType, fileNamePrefix, buttonId) => {
		if (!order?.hmeliorder?.hmeliorder_szam) {
			alert("Hiányzó rendelésszám, nem lehet dokumentumot generálni!");
			return;
		}

		setLoading(buttonId);

		try {
			const reportData = {
				report_type: reportType,
				hmeliorder_szam: order.hmeliorder.hmeliorder_szam,
				json: 1,
				download: true
			};

			const response = await dataService.getReport(reportData);

			if (response.data?.status === "ok" && response.data?.data?.pdf_file_b64) {
				downloadPDF(response.data.data.pdf_file_b64, `${fileNamePrefix}_${order.hmeliorder.hmeliorder_szam}`);
			} else {
				throw new Error(response.data?.message || `Nem sikerült a(z) ${fileNamePrefix} generálása`);
			}
		} catch (error) {
			console.error(`Hiba a(z) ${fileNamePrefix} generálása közben:`, error);
			alert(`Hiba történt a dokumentum generálása során: ${error.message || "Ismeretlen hiba"}`);
		} finally {
			setLoading(null);
		}
	};

	const handleModalOptionChange = (e) => {
		const { name, value, type, checked } = e.target;
		setModalOptions((prev) => ({
			...prev,
			[name]: type === "checkbox" ? checked : value,
		}));
	};

	const openModalForReport = (reportType, fileNamePrefix, reportName) => {
		setCurrentReport({ reportType, fileNamePrefix, reportName });
		setModalStep("form");
		setModalMessage("");
		setModalOptions({
			doDownload: true,
			doSendEmail: false,
			sendToPartner: !!order.partner?.partner_email,
			customEmail: "",
			sendToCustom: true,
		});
		setIsModalOpen(true);
	};

	const handleConfirmModal = async () => {
		if (!order?.hmeliorder?.hmeliorder_szam) {
			setModalMessage("Hiányzó rendelésszám, nem lehet dokumentumot generálni!");
			return;
		}

		if (!modalOptions.doDownload && !modalOptions.doSendEmail) {
			setModalStep("error");
			setModalMessage("Kérjük, válasszon legalább egy műveletet!");
			return;
		}

		const { reportType, fileNamePrefix } = currentReport;
		let emailRecipients = [];

		if (modalOptions.doSendEmail) {
			if (modalOptions.sendToPartner && order.partner?.partner_email) {
				emailRecipients.push(order.partner.partner_email);
			}
			if (modalOptions.sendToCustom && modalOptions.customEmail) {
				if (/^\S+@\S+\.\S+$/.test(modalOptions.customEmail)) {
					emailRecipients.push(modalOptions.customEmail);
				} else {
					setModalStep("error");
					setModalMessage("Kérjük, adjon meg egy érvényes egyedi e-mail címet!");
					return;
				}
			}
			if (emailRecipients.length === 0) {
				setModalStep("error");
				setModalMessage("Nincs kiválasztott címzett az e-mail küldéséhez!");
				return;
			}
		}

		try {
			setModalStep("loading");

			const reportData = {
				report_type: reportType,
				hmeliorder_szam: order.hmeliorder.hmeliorder_szam,
				json: 1,
				download: modalOptions.doDownload,
				email_to: emailRecipients,
			};

			const response = await dataService.getReport(reportData);

			if (response.data?.status === "ok") {
				if (modalOptions.doDownload && response.data?.data?.pdf_file_b64) {
					downloadPDF(response.data.data.pdf_file_b64, `${fileNamePrefix}_${order.hmeliorder.hmeliorder_szam}`);
				}

				setModalStep("success");
				setModalMessage(response.data?.message || "A művelet sikeresen végrehajtva!");

				setTimeout(() => {
					setIsModalOpen(false);
				}, 2000);
			} else {
				throw new Error(response.data?.message || `Nem sikerült a(z) ${fileNamePrefix} generálása`);
			}
		} catch (err) {
			console.error(`Hiba a(z) ${fileNamePrefix} generálása közben:`, err);
			setModalStep("error");
			setModalMessage(`Hiba történt: ${err.message || "Ismeretlen hiba"}`);
		}
	};

	const commonButtonStyle = {
		fontSize: 20,
		fontWeight: 600,
		borderWidth: 2,
		minHeight: 80,
		width: "100%",
		marginBottom: "1rem"
	};

	return (
		<TablerLayout title="">
			<div className="row justify-content-center">
				<div className="col-md-10 mb-4">
					<div className="text-center my-4">
						<h2 className="fw-bold">A rendelés rögzítése sikeresen megtörtént, készen van a méretlap!</h2>
						<div className="text-center my-4 justify-content-center d-flex">
							<h2 className="fw-bold" style={{ backgroundColor: "#5d9534", color: "#fff", padding: "1rem", width: "50%" }}>
								{order.hmeliorder.hmeliorder_specific_id}
							</h2>
						</div>
					</div>
					<div className="card shadow-sm rounded-4">
						<div className="card-body py-5">
							<div className="d-flex flex-column align-items-center gap-3">
								<button
									type="button"
									className="btn btn-primary btn-lg"
									onClick={() => openModalForReport("elit_report", "Meretlap", "Méretlap")}
									disabled={loading === "meretlap"}
									style={commonButtonStyle}
								>
									{loading === "meretlap" ? (
										<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									) : (
										<i className="ti ti-printer me-2"></i>
									)}
									Méretlap nyomtatása
								</button>

								{/* <button
									type="button"
									className="btn btn-info btn-lg"
									onClick={() => openModalForReport("dijbekero_report", "Dijbekero", "Díjbekérő")}
									disabled={loading === "dijbekero"}
									style={commonButtonStyle}
								>
									{loading === "dijbekero" ? (
										<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									) : (
										<i className="ti ti-printer me-2"></i>
									)}
									Díjbekérő nyomtatása
								</button> */}
								
								<button
									type="button"
									className="btn btn-secondary btn-lg"
									onClick={() => navigate("/Szamlazas", { state: { from: '/MeretlapNyomtatas' } })}
									disabled={loading === "elolegszamla"}
									style={commonButtonStyle}
								>
									{loading === "elolegszamla" ? (
										<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									) : (
										<i className="ti ti-printer me-2"></i>
									)}
									Számlázás
								</button>

								{/* <button
									type="button"
									className="btn btn-success btn-lg"
									onClick={() => openModalForReport("szamla_report", "Szamla", "Számla")}
									disabled={loading === "szamla"}
									style={commonButtonStyle}
								>
									{loading === "szamla" ? (
										<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									) : (
										<i className="ti ti-printer me-2"></i>
									)}
									Számla nyomtatása
								</button>  */}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Nyomtató Modal */}
			{isModalOpen && (
				<div className="modal modal-blur fade show" tabIndex="-1" style={{ display: "block" }} onClick={modalStep !== "loading" ? () => setIsModalOpen(false) : undefined}>
					<div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">{currentReport.reportName} PDF riport</h5>
								<button type="button" className="btn-close" onClick={modalStep !== "loading" ? () => setIsModalOpen(false) : undefined} disabled={modalStep === "loading"}></button>
							</div>

							{modalStep === "loading" && (
								<div className="modal-body text-center py-5">
									<div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}></div>
									<h4>Művelet folyamatban...</h4>
									<p className="text-muted">Kérjük, várjon, a dokumentum generálása folyamatban van.</p>
								</div>
							)}

							{modalStep === "success" && (
								<div className="modal-body text-center py-5">
									<div className="mb-3 text-success">
										<i className="ti ti-circle-check" style={{ fontSize: "3rem" }}></i>
									</div>
									<h4>Sikeres művelet!</h4>
									<p className="text-muted">{modalMessage}</p>
								</div>
							)}

							{modalStep === "error" && (
								<div className="modal-body">
									<div className="text-center text-danger mb-3">
										<i className="ti ti-alert-circle" style={{ fontSize: "3rem" }}></i>
									</div>
									<div className="alert alert-danger text-center">
										<h4 className="alert-title">Hiba történt!</h4>
										{modalMessage}
									</div>
								</div>
							)}

							{modalStep === "form" && (
								<>
									<div className="modal-body">
										<p>Válassza ki a kívánt műveleteket:</p>
										<div className="row">
											<div className="col">
												<div className="form-check form-switch mb-3">
													<input className="form-check-input" type="checkbox" name="doDownload" id="doDownloadCheck" checked={modalOptions.doDownload} onChange={handleModalOptionChange} />
													<label className="form-check-label" htmlFor="doDownloadCheck">
														<i className="ti ti-download me-2"></i>PDF letöltése
													</label>
												</div>
											</div>
											<div className="col">
												<div className="form-check form-switch mb-3">
													<input className="form-check-input" type="checkbox" name="doSendEmail" id="doSendEmailCheck" checked={modalOptions.doSendEmail} onChange={handleModalOptionChange} />
													<label className="form-check-label" htmlFor="doSendEmailCheck">
														<i className="ti ti-mail me-2"></i>PDF küldése e-mailben
													</label>
												</div>
											</div>
										</div>

										{modalOptions.doSendEmail && (
											<div className="mt-3 border-top pt-3">
												<h6>E-mail címzettek:</h6>
												{order.partner?.partner_email ? (
													<div className="form-check">
														<input className="form-check-input" type="checkbox" name="sendToPartner" id="sendToPartnerCheck" checked={modalOptions.sendToPartner} onChange={handleModalOptionChange} />
														<label className="form-check-label" htmlFor="sendToPartnerCheck">
															{order.partner.partner_name} (<code>{order.partner.partner_email}</code>)
														</label>
													</div>
												) : (
													<p className="text-muted small">A partnerhez nem tartozik e-mail cím.</p>
												)}
												<div className="input-group mt-2">
													<div className="input-group-text">
														<input className="form-check-input mt-0" type="checkbox" name="sendToCustom" checked={modalOptions.sendToCustom} onChange={handleModalOptionChange} aria-label="Checkbox for following text input" />
													</div>
													<input type="email" className="form-control" name="customEmail" placeholder="Egyedi e-mail cím" value={modalOptions.customEmail} onChange={handleModalOptionChange} />
												</div>
											</div>
										)}
									</div>
									<div className="modal-footer">
										<button type="button" className="btn me-auto" onClick={() => setIsModalOpen(false)}>
											Mégse
										</button>
										<button type="button" className="btn btn-primary" onClick={handleConfirmModal} disabled={!modalOptions.doDownload && !modalOptions.doSendEmail}>
											<i className="ti ti-check me-2"></i>
											Műveletek végrehajtása
										</button>
									</div>
								</>
							)}

							{modalStep === "error" && (
								<div className="modal-footer">
									<button type="button" className="btn" onClick={() => setModalStep("form")}>
										<i className="ti ti-arrow-left me-2"></i>Vissza az űrlaphoz
									</button>
									<button type="button" className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>
										Bezárás
									</button>
								</div>
							)}
						</div>
					</div>
				</div>
			)}
			{isModalOpen && <div className="modal-backdrop fade show"></div>}
		</TablerLayout>
	);
}

export default MeretlapNyomtatas;
